import type { ClientKind } from '@/kinds/kind'
import { afterPatch, apply, defaults, displayName, initialStatus, validate } from './apply'
import { pageSpec, pageStatus, type PageSpec, type PageStatus } from './schema'
import { PageDetail, PageForm, PageRow } from './components'

export const pageKind: ClientKind<PageSpec, PageStatus> = {
  name: 'Page',
  version: 1,
  spec: pageSpec,
  status: pageStatus,
  defaults,
  validate,
  initialStatus,
  displayName,
  apply,
  afterPatch,
  actions: [],
  ListRow: PageRow,
  Detail: PageDetail,
  Form: PageForm,
  workspaceScoped: true,
}

export * from './schema'
export type { PageResource } from './apply'
